import { createAction } from "@reduxjs/toolkit";
export var init = createAction("user/init");
export var logout = createAction("user/logout");
export var login = createAction("user/login");
export var changeName = createAction("user/changeName");
